import { render } from "./EnbSuggestion.vue?vue&type=template&id=74d74ec6&scoped=true"
import script from "./EnbSuggestion.vue?vue&type=script&lang=js"
export * from "./EnbSuggestion.vue?vue&type=script&lang=js"

import "./EnbSuggestion.vue?vue&type=style&index=0&id=74d74ec6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d74ec6"]])

export default __exports__